import { useDialogStore } from '@/components/dialog/FullScreenBackDrop'
import { useAuthStore } from '@/store/auth'
import { usePathname, useRouter } from 'next/navigation'

export const usePrivilege = () => {
  const auth = useAuthStore()
  const router = useRouter()
  const pathname = usePathname()
  const dialog = useDialogStore()

  const openSignin = () => {
    if (auth.user?.status !== 'ACTIVE') {
      if (window.innerWidth < 900) {
        router.push(`/auth/signin?redirect=${pathname}`)
      } else {
        dialog.push('login')
      }
      return
    }
  }

  return {
    openSignin,
  }
}
